import type { DocumentViewerControls } from '@ctw/shared/content/document-viewer/document-viewer';
import { createContext, memo, type PropsWithChildren, useContext, useMemo } from 'react';

interface DocumentViewerState {
  controls: DocumentViewerControls;
}

const DocumentViewerContext = createContext<DocumentViewerState | undefined>(undefined);

interface DocumentViewerProviderProps extends DocumentViewerState, PropsWithChildren {}

export const DocumentViewerProvider = memo(
  ({ controls, children }: DocumentViewerProviderProps) => {
    const state: DocumentViewerState = useMemo(() => ({ controls }), [controls]);

    return (
      <DocumentViewerContext.Provider value={state}>{children}</DocumentViewerContext.Provider>
    );
  },
);

export const useDocumentViewerContext = () => {
  const context = useContext(DocumentViewerContext);

  if (!context) {
    throw new Error('useDocumentViewerContext must be used inside a DocumentViewerProvider');
  }

  return context;
};
